import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'

import { Get, Put, Post, Delete } from 'utils/axios-token'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import Lang from 'Lang/General'
import { FormTemplate } from '../assets'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      showCreateForm: false,
      showUpdateForm: false,
      showSubmittedForms: false,
      subscribedPackage: false,
      formMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      query: {},
      newForm: {
        name: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        confirmation_message: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        content: [],
        values: [],
        status: 'ACTIVE',
        email_recipients: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        email_bcc: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        email_subjects: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        email_content: {
          en: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. ',
          de: 'Sie haben eine E-Mail von {{ .fex_user_email }}, {{ .company_name }}.',
          it: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. ',
          nl: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. '
        },
        send_email_content: {
          en: '',
          de: '',
          it: '',
          nl: ''
        },
        background_color: '',
        site_funnel_id: null,
        recipient_group_ids: []
      },
      formTemplateIndex: -1,
      selectedForm: {},
      selectedFormOriginal: {},
      forms: [],
      showConfirmDeleteModal: false,
      submittedForms: [],
      showDuplicateModal: false
    }

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => typeof error === 'string'
      ? toast.error( error )
      : Object.values( error ).map( item => toast.error( item.replace( /_/g, ' ' ) ) )

    onChangeFormsHOC = ( key, val ) => this.setState({ [ key ]: val })

    getForms = query => {
      this.setState({ query }, () => {
        Get(
          `/api/v1/fex/forms?query=${convertSearchObjectToBase64(query)}`,
          this.getFormsSuccess,
          this.getFormsError,
          this.load
        )
      })
    }
    getFormsSuccess = payload => this.setState({ forms: payload.data })
    getFormsError = error => this.requestError( error )

    getSelectedForm = ( id, isUpdate ) => Get(
      `/api/v1/fex/forms/${ id }`,
      (payload) => this.getSelectedFormSuccess( payload, isUpdate ),
      this.getSelectedFormError,
      this.load
    )
    getSelectedFormSuccess = ( payload, isUpdate ) => {
      let tmpSelectedForm = _.cloneDeep( payload )
      tmpSelectedForm.content = typeof tmpSelectedForm.content === 'string'
        ? JSON.parse( tmpSelectedForm.content )
        : tmpSelectedForm.content
      tmpSelectedForm.values = typeof tmpSelectedForm.values === 'string'
        ? JSON.parse( tmpSelectedForm.values )
        : tmpSelectedForm.values
      this.setState({ selectedFormOriginal: payload, selectedForm: tmpSelectedForm, showUpdateForm: isUpdate, showDuplicateModal: !isUpdate })
    }
    getSelectedFormError = error => this.requestError( error )

    createForm = data => Post(
      `/api/v1/fex/forms`,
      {
        ... data,
        client_id: this.props.data.selectCenterReducer.selectedCenter.center.client_id
      },
      this.createFormSuccess,
      this.createFormError,
      this.load
    )
    createFormSuccess = () => {
      this.requestSuccess( 'Form is created successfully.' )
      this.setState({
        showCreateForm: false,
        newForm: this.state.formTemplateIndex > -1
          ? FormTemplate[ this.state.formTemplateIndex ].form_template
          : {
            name: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            confirmation_message: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            content: [],
            values: [],
            status: 'ACTIVE',
            email_recipients: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            email_bcc: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            email_subjects: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            email_content: {
              en: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. ',
              de: 'Sie haben eine E-Mail von {{ .fex_user_email }}, {{ .company_name }}.',
              it: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. ',
              nl: 'You received an email from {{ .fex_user_email }}, {{ .company_name }}. '
            },
            send_email_content: {
              en: '',
              de: '',
              it: '',
              nl: ''
            },
            background_color: '',
            site_funnel_id: null,
            recipient_group_ids: []
        }
      })
      this.getForms(this.state.query)
    }
    createFormError = error => this.requestError( error )

    updateForm = data => Put(
      `/api/v1/fex/forms/${ data.id }`,
      data,
      this.updateFormSuccess,
      this.updateFormError,
      this.load
    )
    updateFormSuccess = () => {
      this.requestSuccess( 'Form is updated successfully.' )
      this.setState({ showUpdateForm: false })
      this.getForms(this.state.query)
    }
    updateFormError = error => this.requestError( error )

    getSubmittedForms = form_id => Get(
      `/api/v1/fex/forms/${form_id}/results`,
      this.getSubmittedFormsSuccess,
      this.getSubmittedFormsError,
      this.load
    )
    getSubmittedFormsSuccess = payload => this.setState({ submittedForms: payload, showSubmittedForms: true })
    getSubmittedFormsError = error => this.requestError( error )

    deleteForm = id => Delete(
      `/api/v1/fex/forms/${ id }`,
      this.deleteFormSuccess,
      this.deleteFormError,
      this.load
    )
    deleteFormSuccess = () => {
      this.requestSuccess( Lang[ 'FORM_DELETED_SUCCESSFULLY' ][ this.props.selectedLanguage ] )
      this.getForms(this.state.query)
      this.setState({ showConfirmDeleteModal: false })
    }
    deleteFormError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          { ... this.state }
          onLoadForms={ this.state.loading }

          onChangeFormsHOC={ this.onChangeFormsHOC }
          getForms={ this.getForms }
          getSelectedForm={ this.getSelectedForm }
          getSubmittedForms={ this.getSubmittedForms }
          createForm={ this.createForm }
          updateForm={ this.updateForm }
          deleteForm={ this.deleteForm }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC
